angular.module("listingOverviewModule").component("listingSave", {
    templateUrl: "listingSave/listingSave.html",
    bindings: {
        isHouse: '@',
        isTownhouse: '@',
        photo: '@',
        listingId: '@',
        saveDeleteStatus: '@'
    },
    controller: ["$timeout", "$element", 'PubSub', function ($timeout, $element, PubSub) {
        let self = this;
        // this.$onInit = function () {
            
        // };
        this.saveClick = function () {
            $timeout(() => {
                let $el = document.querySelector('._v3 .cr-save-to-profile button');
                if ($el) {
                    $el.click();
                } else {
                    $el = document.querySelector('.listing_v2 .links-icons .cr-save-to-profile button');
                    if ($el) {
                        $el.click();
                    }
                }
            });
        }

        PubSub.subscribe('updateListing-'+this.listingId, function(listing) {
            if (listing) {
                self.saveDeleteStatus = listing.saveDeleteStatus;
            }
        });

    }]
});
